import type { ApplicationSettingSms } from '@lighthouse/core'
import { useAtomAction, useAtomData } from '@lighthouse/shared'
import * as React from 'react'
import { useCallback, useEffect, useMemo } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import styled from 'styled-components'
import { debounce } from 'throttle-debounce'

import { updateAppAtom } from '@/atoms/application/action'
import { applicationSettingAtom } from '@/atoms/application/state'

import { SettingCard } from '../SettingCard'
import { SmsConfig } from './SmsConfig'

interface SettingSEOProps {}

const Contain = styled.form`
    width: 100%;
    font-size: var(--font-size-normal);
`

const SettingSEO: React.FC<SettingSEOProps> = () => {
    const sms = useAtomData(
        applicationSettingAtom,
        useCallback(s => s?.sms, [])
    )
    const { run: updateAppSetting } = useAtomAction(updateAppAtom)

    const methods = useForm<ApplicationSettingSms>({
        mode: 'onChange',
        defaultValues: sms
    })
    const { watch, control, reset } = methods

    const handleSubmit = useMemo(
        () =>
            debounce(500, async (value: ApplicationSettingSms) => {
                const isSuccess = await updateAppSetting({
                    config: {
                        sms: value
                    }
                })
            }),
        [updateAppSetting]
    )

    useEffect(() => {
        const { unsubscribe } = watch((value, { name, type }) => {
            handleSubmit(value as ApplicationSettingSms)
        })
        return unsubscribe
    }, [handleSubmit, updateAppSetting, watch])

    return (
        <Contain>
            <FormProvider {...methods}>
                <SettingCard title="短信发送方">
                    <div style={{ width: 430, marginTop: 16 }}>
                        <SmsConfig />
                    </div>
                </SettingCard>
            </FormProvider>
        </Contain>
    )
}

export default SettingSEO
